import React, { useState, useRef, useEffect } from 'react';
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";  // Import Firestore configuration
import { useNavigate, useLocation } from "react-router-dom";
import html2canvas from 'html2canvas';
import { MdOutlineSupportAgent, MdWorkHistory, MdFeed, MdOutlineFeed } from "react-icons/md";
import { BsPlayBtn, BsPlayBtnFill } from "react-icons/bs";
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { MdLiveTv } from "react-icons/md";
import { BsPersonWorkspace } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { FaMessage, FaRegMessage } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import Cookies from 'js-cookie';
import { RiAccountCircleLine } from "react-icons/ri";
import './header.css';
import { AiOutlineDashboard, AiFillDashboard } from "react-icons/ai";
import Logo from '../assets/editortask_logo.png';
import Photosicon from '../assets/photos_icon.png';
import { IoAddCircle, IoAddCircleOutline } from "react-icons/io5";
import SidebarMenu from './SidebarMenu';
export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [messages, setmessages] = useState(0);
  const [guid, setGuid] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [loginName, setLoginName] = useState("");
  // Automatically check for logged-in user on page load
  const [isOpen, setIsOpen] = useState(false);

  //login
  const [userlogin, setuserlogin] = useState(false); // State for popup
  const popupRef = useRef(null);    // Ref for direct DOM manipulation


  //prod 

  useEffect(() => {
    checkUserAuth(setUser);  // Auto-login
    const existingUser = Cookies.get("guid");   // Check for existing login

    if (existingUser != null) {
      setuserlogin(true);
      const photo = Cookies.get("login_photoURL");

      setPhotoURL(photo);
    } else {
      setuserlogin(false);   // Auto-open login popup if not logged in
    }
  }, []);
  const handleGoogleLogin = async () => {
    const userData = await signInWithGoogle();
    setUser(userData);    // Set user state
    setTimeout(() => {
      window.location.reload(); // Reloads the page after OTP verification
    }, 2000);
  };
  const handleGoogleLogout = async () => {
    await googleLogout();
    setUser(null);
    // setGuid("");
    // setPhotoURL("");
    // setLoginName("");
    setTimeout(() => {
      window.location.reload(); // Reloads the page after OTP verification
    }, 2000);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);

  };
  return (
    <div>
      <div className="header">
        <SidebarMenu />
        <div className="container_size">
          <div className='header_size'>
            <div className="left_body">
              <img onClick={() => navigate('/')} className="home-logo-img" src={Logo} alt="Logo" />
              <img onClick={toggleMenu} className="logo-mobile-img" src={Logo} alt="Logo" />
              <div onClick={() => navigate('/')} className='logo-div'>
                <b className='editortask-brand'>Editortask</b>
                <b className='logo-text2'></b>
              </div>
            </div>
            {window.innerWidth > 768 ? (
              // Desktop or wider screen
              (location.pathname !== '/' && (
                <div className="search-body">
                  <input className='search-input'
                    placeholder='Search Hire Editors, Get Tasks Done' />
                  <div className='search-btn' ></div>
                </div>
              ))
            ) : (
              // Mobile view
              <div className="search-body">
                <input className="search-input"
                  placeholder="EditorTask Search..." />
              </div>
            )}
            <div className="menus_body">
              <div
                onClick={() => navigate('/')}
                className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
                title="Home"
              >
                {location.pathname === '/' ? <AiFillHome className="icon" /> : <AiOutlineHome className="icon" />}
                <span className="button-text">Home</span>
              </div>
              {userlogin == true && (
                <div
                  onClick={() => navigate('/dashboard')}
                  className={`menubutton-icon ${location.pathname === '/dashboard' ? 'active' : ''}`}
                  title="Dashboard"
                >
                  {location.pathname === '/dashboard' ? (
                    <AiFillDashboard className="icon" />
                  ) : (
                    <AiOutlineDashboard className="icon" />
                  )}
                  <span className="button-text">Dashboard</span>
                </div>
              )}
              <div
                onClick={() => navigate('/feed')}
                className={`menubutton-icon ${location.pathname === '/feed' ? 'active' : ''}`}
                title="Feed"
              >
                {location.pathname === '/feed' ? <BsPlayBtnFill className="icon" /> : <BsPlayBtn className="icon" />}
                <span className="button-text">Feed</span>
              </div>

              <div
                onClick={() => navigate('/hire-editors')}
                className={`menubutton-icon ${location.pathname === '/hire-editors' ? 'active' : ''}`}
                title="Hire Editors"
              >
                {location.pathname === '/hire-editors' ? <BsPersonWorkspace className="icon" /> : <BsPersonWorkspace className="icon" />}

                <span className="button-text">Editor</span>
              </div>

              <div
                onClick={() => navigate('/jobs')}
                className={`menubutton-icon ${location.pathname === '/jobs' ? 'active' : ''}`}
                title="Jobs"
              >
                {location.pathname === '/jobs' ? <RiSlideshowFill className="icon" /> : <RiSlideshowLine className="icon" />}

                <span className="button-text">Jobs</span>
              </div>

              <div
                onClick={() => navigate('/messageing')}
                className={`messageingmenubutton-icon  ${location.pathname === '/messageing' ? 'active' : ''}`}
                title="Messaging"
              >

                {location.pathname === '/messageing' ? <FaMessage className="icon" /> : <FaRegMessage className="icon" />}
                <span className="button-text">Messaging</span>
                {messages > 0 && (
                  <span className='message_count'>{messages}</span>
                )}
              </div>

              <div
                onClick={() => navigate('/advisers')}
                className={`submenubutton-icon ${location.pathname === '/advisers' ? 'active' : ''}`}
                title="Advisers"
              >
                {location.pathname === '/advisers' ? <BiSupport className="icon" /> : <MdOutlineSupportAgent className="icon" />}
                <span className="button-text">Advisers</span>
              </div>
            </div>

            <div className="right_body">
              {userlogin == true && (

                <img onClick={() => navigate('/account')}
                  className="user-img"
                  src={photoURL}
                  alt="User"
                  onError={(e) => {
                    e.target.onerror = null; // prevent infinite loop
                    e.target.src = Photosicon;
                  }}
                />
              )}
              {userlogin == false && (
                <div className='button-ui' onClick={() => navigate('/login')}>
                  <RiAccountCircleLine className="icon" /> Login
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      <div className={`sidebar ${isOpen ? "open" : ""}`}>


        <div className="sidebar-title" >
          <div className="logo_body" onClick={toggleMenu}>
            <img className="logoimg" src={Logo} alt="Logo" />
            <div className='logo-text'>
              <b>Editor</b><br /><a className='logo-text2'>Task.com</a>
            </div>
          </div>
        </div>

        <div  >
          <table className="sidebar-links">
            <tr>
              <td>
                <div className="tab-title">Editortask</div>
              </td>
            </tr>
                 <tr>
              <td>
                <a className="tab-link" href='/dashboard' title='Categories'>Dashboard</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/categories' title='Categories'>Categories</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" href='/creative-portfolios' title='Creative portfolios'>Creative portfolios</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/hire-editors' title='Hire Editors'>Hire Editors</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='/typing-master' title='Typing Master' >Typing Master</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Post Job' href='/post-job'>Post Job</a>
              </td>
            </tr>
            <tr>
              <td>
                <div className="tab-title" >About</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='About' href='/about'>About us</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='How it Works' href='/how-it-works'>How it Works</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Security' href='/security'>Security</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Sitemap' href='/sitemap'>Sitemap</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" onClick={() => navigate('/help')}>Help & Support</a>
              </td>
            </tr>
            <tr>
              <td>
                <div className="tab-title">Terms</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Privacy Policy' href='/privacy-policy'>Privacy Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Copyright Policy' href='/copyright-policy'>Copyright Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Code of Conduct' href='/code-of-conduct'>Code of Conduct</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Fees and Charges' href='/fees-and-charges'>Fees and Charges</a>
              </td>
            </tr>


            <tr>
              <td>
                <div className="tab-title">Business</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Partners' href='/partners'>Partners</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Skills Showcase' href='/skills'>Skills Showcase</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Locale Services' href='/locale-services'>Locale Services</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Company profile' href='/create-company-profile'>Company profile</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Business & Agency' href='/agency'>Business & Agency</a>
              </td>
            </tr>

            <tr>
              <td>

                <div className="tab-link">
                  © <b>EditorTask -<br /> Kang Technology - {new Date().getFullYear()}</b><br /> All rights reserved  <br /><br /> <a>Update 1/04/2025</a>

                </div>
              </td>
            </tr>
          </table>

        </div>

      </div>

      {/* Overlay */}
      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}

    </div>
  );


}
